module.exports = __webpack_public_path__ + "static/media/SWSCRC6-24.23c67919.mp3";